import React from 'react'
import PropTypes from 'prop-types'

import ApptTypesCard from './ApptTypesCard'
import styles from './styles.css'

const NewPatientApptTypes = ({ newAppointmentTypes, patchAppointmentType }) => (
  <div className={styles.newApptTypeContainer}>
    <h2>New Patient Appointment Types</h2>
    {newAppointmentTypes.map(appointmentType => (
      <ApptTypesCard
        key={appointmentType.id}
        isCloseable
        appointmentType={appointmentType}
        patchAppointmentType={patchAppointmentType}
      />
    ))}
  </div>
)

NewPatientApptTypes.propTypes = {
  newAppointmentTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  patchAppointmentType: PropTypes.func.isRequired,
}

export default NewPatientApptTypes



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/NewPatientApptTypes.js